import apiClient from "./client";

export default function register(data) {
  return new Promise((resolve, reject) => {
    apiClient
      .post("/faniki-register", data)
      .then((response) => {
        resolve(response);
      })
      .catch(function (e) {
        reject(e);
      });
  });
}

export const membersgetApi = () => {
  return new Promise((resolve, reject) => {
    apiClient
      .get("/faniki-members")
      .then((response) => {
        resolve(response);
      })
      .catch(function (e) {
        reject(e);
      });
  });
};
